export default __webpack_public_path__ + "static/media/refer-via-bg.93f86df2.png";